import React, { useState, useEffect } from 'react';
import { fetchRoutingRulesAPI, updateRoutingRuleAPI } from '../services/serverService';
import { FaTimes } from 'react-icons/fa';

const CATEGORIES = ['Bug/Crash', 'Feature Request', 'Billing/Invoice', 'Account/Login Issue', 'Other', 'General Support', 'Bug', 'Access/Permissions', 'Compliance', 'Training'];

export default function RoutingRulesModal({ closeModal, staff }) {
    const [rules, setRules] = useState({});
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    const [successMsg, setSuccessMsg] = useState('');

    useEffect(() => { loadRules(); }, []);

    const loadRules = async () => {
        try {
            const res = await fetchRoutingRulesAPI();
            setRules(res.data || {});
        } catch (err) { setError('Failed to load existing rules.'); } 
        finally { setLoading(false); }
    };

    const handleAddAssignee = async (category, e) => {
        const uid = e.target.value;
        if (!uid) return;

        const currentRule = rules[category] || { assignees: [] };
        if (currentRule.assignees?.find(a => a.uid === uid)) return;

        const selectedStaff = staff.find(s => s.uid === uid);
        const newAssignees = [...(currentRule.assignees || []), { uid: selectedStaff.uid, name: selectedStaff.name }];

        await saveRule(category, newAssignees);
    };

    const handleRemoveAssignee = async (category, uid) => {
        const currentRule = rules[category] || { assignees: [] };
        const newAssignees = (currentRule.assignees || []).filter(a => a.uid !== uid);
        await saveRule(category, newAssignees);
    };

    const saveRule = async (category, assignees) => {
        setSaving(true);
        setError('');
        setSuccessMsg('');
        try {
            await updateRoutingRuleAPI({ category, assignees });
            setRules(prev => ({ ...prev, [category]: { assignees } }));
            setSuccessMsg(`Rule updated for ${category}`);
            setTimeout(() => setSuccessMsg(''), 3000);
        } catch (err) { setError('Failed to update rule.'); } 
        finally { setSaving(false); }
    };

    return (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
            <div style={{ backgroundColor: 'white', padding: '30px', borderRadius: '8px', width: '500px', maxWidth: '90%', maxHeight: '80vh', overflowY: 'auto' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <h2 style={{ margin: 0 }}>Ticket Routing Rules</h2>
                    <button onClick={closeModal} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' }}>&times;</button>
                </div>

                <p style={{ color: '#4a5568', fontSize: '14px', marginBottom: '20px' }}>
                    Add one or more staff to a category. If multiple are added, the system load-balances the assignment and adds the rest as collaborators.
                </p>

                {error && <div style={{ color: '#c53030', backgroundColor: '#fff5f5', padding: '10px', borderRadius: '4px', marginBottom: '15px' }}>{error}</div>}
                {successMsg && <div style={{ color: '#2f855a', backgroundColor: '#f0fff4', padding: '10px', borderRadius: '4px', marginBottom: '15px' }}>{successMsg}</div>}

                {loading ? <p>Loading rules...</p> : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                        {CATEGORIES.map(category => {
                            const currentRule = rules[category];
                            return (
                                <div key={category} style={{ display: 'flex', flexDirection: 'column', gap: '10px', padding: '15px', backgroundColor: '#f7fafc', borderRadius: '6px', border: '1px solid #e2e8f0' }}>
                                    <strong style={{ color: '#2d3748' }}>{category}</strong>
                                    
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                        {(currentRule?.assignees || []).map(assignee => (
                                            <span key={assignee.uid} style={{ fontSize: '12px', backgroundColor: '#e2e8f0', color: '#4a5568', padding: '4px 10px', borderRadius: '12px', display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                {assignee.name.split(' ')[0]}
                                                <FaTimes style={{ cursor: 'pointer', color: '#a0aec0' }} onClick={() => handleRemoveAssignee(category, assignee.uid)} />
                                            </span>
                                        ))}
                                    </div>

                                    <select 
                                        value=""
                                        onChange={(e) => handleAddAssignee(category, e)}
                                        disabled={saving}
                                        style={{ padding: '8px', borderRadius: '4px', border: '1px solid #cbd5e0', width: '100%', backgroundColor: 'white' }}
                                    >
                                        <option value="" disabled>-- Unassigned --</option>
                                        {staff.filter(s => !(currentRule?.assignees || []).find(a => a.uid === s.uid)).map(user => (
                                            <option key={user.uid} value={user.uid}>{user.name} ({user.role})</option>
                                        ))}
                                    </select>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
}